export default __webpack_public_path__ + "static/operational-efficiency-small-8ccc7db3b30d454519408f750bbcbb9a.png";